module.exports = __webpack_public_path__ + "img/oil.d49cfce.jpg";